import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Account, DocSubmitType, DocSubmitTypeEnum } from 'app/model/entities/entity-model';
import { DialogBaseComponent, DialogParams } from 'app/shared/dialog-base.component';
import { DomainService } from 'app/shared/domain.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QboCustomerLinkDialogComponent } from './qbo-customer-link-dialog.component';

interface EditAccountDialogParams extends DialogParams {
  account: Account;
}

@Component({
    templateUrl: './edit-account-dialog.component.html',
    standalone: false
})
export class EditAccountDialogComponent extends DialogBaseComponent<EditAccountDialogParams> {
  @ViewChild('form') form: NgForm;

  account: Account;
  docSubmitTypes: DocSubmitType[];

  constructor(
    public config: DynamicDialogConfig<any>, public dialogRef: DynamicDialogRef, public domainService: DomainService
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: 'Edit Account',
      width: '900px',
      height: '740px',
    });
    this.prepare();
  }

  // 
  private async prepare() {
    this.account = this.params.account;
    this.docSubmitTypes = this.dbQueryService.getAllCached(DocSubmitType)
    
    this.isPageReady = true;
  }

  unformatCurrency(value: string) {
    const newValue = value.replace(/[$,]/g, "");
    const num = Number(newValue);
    
    return Number.isNaN(num) ? null : num;
  }

  canSave() {
    return this.uow.hasChanges();
  }
  
  async ok() {
    if (this.account.invoiceDocSubmitTypeId == DocSubmitTypeEnum.PrintAndEmail || this.account.invoiceDocSubmitTypeId == DocSubmitTypeEnum.Email) {
      if (this.account.invoiceEmail == null) {
        await this.dialogService.showOkMessage('Unable to save', 'This Doc Submit Type needs an invoice and manifest email. Enter an email address.');
        return false;
      }
    }
    this.account.modTs = new Date();
    const ea = this.account.entityAspect;
    if (!ea.validateEntity()) {
      const vErrors = ea.getValidationErrors();
      const errMsg = vErrors.map(ve => ve.errorMessage).join('<br>');
      await this.dialogService.showOkMessage('Cannot save - Validation Errors', errMsg);
      return false;
    }
    
    // TODO: run validations locally first 
    await this.dbSaveService.saveChanges();
    
    this.dialogRef.close(true);
  }

  async cancel() {
    this.dialogRef.close(false);
  }

  // Expose the underlying PrimeNG DialogService so this dialog qualifies as an IDialogParent
  // when opening a nested dialog (see DialogBaseComponent.open).
  getPngDialogService() {
    return this.domainService.pngDialogService;
  }

  async openQboCustomerLinkDialog() {
    await DialogBaseComponent.open(QboCustomerLinkDialogComponent, this, {
      account: this.account,
    });
  }

}
